/**
 * Waiting for the typing to stop.
 *
 * The two tools that need a dictionary need it: their conversion runs a
 * lattice decode, which is fast but not free, and doing it on every keystroke
 * of a pasted paragraph is work nobody sees the result of. The rest convert on
 * the keystroke, because reading a syllable that is already spelled out costs
 * nothing worth deferring.
 */

/** How long to wait after a keystroke before acting. */
const defaultDelay = 150;

/**
 * Wrap an action so that it runs once the calls stop coming.
 */
export function debounced(
  action: () => void,
  delay = defaultDelay,
): () => void {
  let pending: ReturnType<typeof setTimeout> | undefined;

  return () => {
    if (pending !== undefined) {
      clearTimeout(pending);
    }

    pending = setTimeout(() => {
      pending = undefined;
      action();
    }, delay);
  };
}
